import { render, staticRenderFns } from "./FeedbackIndex.vue?vue&type=template&id=2c969f66&scoped=true"
import script from "./FeedbackIndex.vue?vue&type=script&lang=js"
export * from "./FeedbackIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c969f66",
  null
  
)

export default component.exports